

function App() {
    return (
      <div className="App">
        <div>
    <nav className="navbar navbar-expand-sm navbar-light">
      <div className="container">
        <a className="navbar-brand"><i className="uil" /> Ramba</a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon" />
          <span className="navbar-toggler-icon" />
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav mx-auto">
            <li className="nav-item">
              <a href="#about" className="nav-link"><span data-hover="About">About</span></a>
            </li>
            
            <li className="nav-item">
              <a href="#contact" className="nav-link"><span data-hover="Contact">Contact</span></a>
            </li>
          </ul>
          <ul className="navbar-nav ml-lg-auto">
            <div className="ml-lg-4">
              <div className="color-mode d-lg-flex justify-content-center align-items-center">
                <i className="color-mode-icon" />
                Color mode
              </div>
            </div>
          </ul>
        </div>
      </div>
    </nav>
    {/* ABOUT */}
    <section className="about full-screen d-lg-flex justify-content-center align-items-center" id="about">
      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-md-12 col-12 d-flex align-items-center">
            <div className="about-text">
              <h1 className="animated animated-text">
                <span className="mr-2">Hey folks, Welcome to</span>
                <div className="animated-info">
                  <span className="animated-item">Ramba</span>
                  <span className="animated-item">Ramba</span>
                  <span className="animated-item">Ramba</span>
                </div>
              </h1>
              <p>
              Welcome to Ramba, a medical software platform designed to connect HIV/AIDS patients with doctors for virtual consultations, medical advice, and other related services. Our mission is to provide a safe, secure, and convenient way for HIV/AIDS patients to receive the medical attention they need, without having to leave their homes.
  
  With Ramba, patients can easily schedule virtual consultations with qualified healthcare providers, share medical records and test results securely, and receive advice and treatment options tailored to their individual needs. Our platform is designed to be user-friendly and accessible to all, regardless of location or physical limitations.
  
  We understand that living with HIV/AIDS can be challenging, and accessing quality medical care can be difficult for many patients. That's why we have created Ramba, to provide an innovative solution that connects patients with the care they need, when they need it.
  
              </p>
              
            </div>
          </div>
          <div className="col-lg-5 col-md-12 col-12">
            <div className="about-image svg">
              <img src="images/undraw/undraw_software_engineer_lvl5.svg" className="img-fluid" alt="svg image" />
            </div>
          </div>
        </div>
      </div>
    </section>
   
   
    {/* CONTACT */}
    <section className="contact py-5" id="contact">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 mr-lg-5 col-12">
            <div className="google-map w-100">
             
              <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d3987.4759552255823!2d30.052274923508705!3d-1.9634037481914195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2srw!4v1678179374580!5m2!1sen!2srw" width={400} height={300} style={{border:0}} allowFullScreen loading={'lazy'} />
            </div>
            <div className="contact-info d-flex justify-content-between align-items-center py-4 px-lg-5">
              <div className="contact-info-item">
                <h3 className="mb-3 text-white">Say hello</h3>
                <p className="footer-text mb-0">0787025362, 0789728513</p>
                <p><a href="mailto:niyitegekam@gmail.com">niyitegekam@gmail.com, mwenedaclaude2020@gmail.com</a></p>
              </div>
              <ul className="social-links">
                <li><a href="#" className="uil uil-dribbble" data-toggle="tooltip" data-placement="left" title="Dribbble" /></li>
                <li><a href="#" className="uil uil-instagram" data-toggle="tooltip" data-placement="left" title="Instagram" /></li>
                <li><a href="#" className="uil uil-youtube" data-toggle="tooltip" data-placement="left" title="Youtube" /></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className="contact-form">
              <h2 className="mb-4">Interested to work together? Let's talk</h2>
              <form action method="get">
                <div className="row">
                  <div className="col-lg-6 col-12">
                    <input type="text" className="form-control" name="name" placeholder="Your Name" id="name" />
                  </div>
                  <div className="col-lg-6 col-12">
                    <input type="email" className="form-control" name="email" placeholder="Email" id="email" />
                  </div>
                  <div className="col-12">
                    <textarea name="message" rows={6} className="form-control" id="message" placeholder="Message" defaultValue={""} />
                  </div>
                  <div className="ml-lg-auto col-lg-5 col-12">
                    <input type="submit" className="form-control submit-btn" defaultValue="Send Button" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* FOOTER */}
    <footer className="footer py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-12">                                
            <p className="copyright-text text-center"><a rel="nofollow" href="/termsandcondition">Terms and conditions</a></p>
          </div>
        </div>
      </div>
    </footer>
  </div>
  
      </div>
    );
  }
  
  export default App;
  